export * from './SendIcon';


// WEBPACK FOOTER //
// ./src/components/Icons/index.js